import IconFloppyDisk from '@apollo/icons/default/IconFloppyDisk.svg';
import { IconButton } from '@apollo/orbit';
import React from 'react';
import { Link, useLocation } from 'react-router-dom';

import { OpenInExplorer } from 'src/components/common/openInExplorer/OpenInExplorer';
import { Tooltip } from 'src/components/common/tooltip/Tooltip';
import Config from 'src/lib/config';
import { setOverlayVisibleLocation } from 'src/lib/routing';

type OperationSignatureActionsProps = {
  location: ReturnType<typeof useLocation>;
  graphId: string;
  graphVariant?: string;
  signature?: string;
};

export const OperationSignatureActions = (
  props: OperationSignatureActionsProps,
) => {
  const { location, graphId, graphVariant, signature } = props;

  return (
    <>
      <Tooltip label="Save to an Operation Collection">
        <IconButton
          variant="secondary"
          aria-label="Save"
          type="button"
          size="sm"
          icon={<IconFloppyDisk />}
          as={Link}
          to={setOverlayVisibleLocation({
            location,
            overlayName: Config.modals.saveMetricsOperationToCollection,
          })}
        />
      </Tooltip>
      <OpenInExplorer
        size="sm"
        graphId={graphId}
        graphVariant={graphVariant || ''}
        document={signature || ''}
        label="Run in Explorer"
        iconOnly
      />
    </>
  );
};
